// extracted by mini-css-extract-plugin
export default {"colored-link":"PrivacyFooter_colored-link_1Y57_","coloredLink":"PrivacyFooter_colored-link_1Y57_"};